var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"custom-spinner",class:("spinner-" + _vm.size)},[_c('div',{staticClass:"spinner-circle"})]),_c('div',{staticClass:"loading-tip"},[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []

export { render, staticRenderFns }